import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import formatName from 'I18n/utils/formatName';
import { Popover } from 'foundations-components/transitional/components/Popover';
import uniq from 'hs-lodash/uniq';
import { useMemo, useState } from 'react';
import { usePlaylist, useUserOwnsPlaylist } from '../savedItemsQueries';
import { useIsHubspotPlaylist } from '../savedItemsHooks';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreatedByLabel = ({
  playlist
}) => {
  const isOwnedByUser = useUserOwnsPlaylist(playlist);
  const isHubspotPlaylist = useIsHubspotPlaylist(playlist);
  if (isHubspotPlaylist) return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "learningCenter.myPlaylists.createdBy",
    options: {
      user: 'HubSpot Academy'
    }
  });
  if (isOwnedByUser) return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myPlaylists.createdByMe"
  });
  const {
    firstName,
    lastName
  } = playlist.ownerUser;
  const displayName = formatName({
    firstName,
    lastName
  });
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "learningCenter.myPlaylists.createdBy",
    options: {
      user: displayName
    }
  });
};
const AssignorsPopup = ({
  displayNames
}) => {
  return /*#__PURE__*/_jsx(List, {
    padding: "600 !important",
    children: displayNames.map((displayName, index) => /*#__PURE__*/_jsx(ListItem, {
      marginBlock: index === 0 || index === displayNames.length - 1 ? undefined : '500',
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-100",
        children: displayName
      })
    }, `assignor_popup_${index}`))
  });
};
const AssignedByLabel = ({
  playlist: {
    assignments
  }
}) => {
  const [isMoreAssignorsPopoverOpen, setIsMoreAssignorsPopoverOpen] = useState(false);
  const assignorDisplayNames = useMemo(() => uniq(assignments.map(({
    assignorUser: {
      firstName,
      lastName
    }
  }) => formatName({
    firstName,
    lastName
  }))), [assignments]);
  const displayName = assignorDisplayNames[0];
  const onMoreAssignorsLinkClick = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsMoreAssignorsPopoverOpen(true);
  };
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "learningCenter.myPlaylists.assignedBy",
    options: {
      user: assignorDisplayNames.length > 1 ? /*#__PURE__*/_jsx(Popover, {
        content: /*#__PURE__*/_jsx(AssignorsPopup, {
          displayNames: assignorDisplayNames
        }),
        onOpenChange: e => setIsMoreAssignorsPopoverOpen(e.target.value),
        open: isMoreAssignorsPopoverOpen,
        use: "longform",
        children: /*#__PURE__*/_jsx(Button, {
          onClick: onMoreAssignorsLinkClick,
          use: "link",
          children: /*#__PURE__*/_jsxs(Text, {
            as: "span",
            typography: "detail-200",
            children: [displayName, /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myPlaylists.otherCount",
              options: {
                count: assignorDisplayNames.length - 1
              }
            })]
          })
        })
      }) : displayName
    }
  });
};
export const PlaylistCreatedAndAssignedByLabel = _ref => {
  let {
      playlistId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    playlist
  } = usePlaylist(playlistId);
  if (!playlist) return null;
  return /*#__PURE__*/_jsx(Text, Object.assign({
    as: "small",
    "data-test-id": "created-by",
    display: "block",
    role: "label"
  }, props, {
    children: playlist.assignments.length ? /*#__PURE__*/_jsx(AssignedByLabel, {
      playlist: playlist
    }) : /*#__PURE__*/_jsx(CreatedByLabel, {
      playlist: playlist
    })
  }));
};
export default PlaylistCreatedAndAssignedByLabel;